import { useContext, useState, useEffect } from "react";
import { Language } from "../../../App";
import {
    Col, 
    Modal,
    ModalFooter,
    ModalHeader, 
    Row,
  } from "reactstrap";

const AddMultipleOptionModal = ({ isOpen, toggle, saveOptions, onCancel }) => {
    const { lang } = useContext(Language);
    const initialOptionsData = [""];
    const [optionsData, setOptionsData] = useState(initialOptionsData);
  
    // Reset form when modal opens
    useEffect(() => {
      if (isOpen) {
        setOptionsData(initialOptionsData);
      }
    }, [isOpen]);

    const addOption = () => {
      const newOption = "";
      const updatedOptionsData = [...optionsData];
      updatedOptionsData.push(newOption);
      setOptionsData(updatedOptionsData);
    };
  
    const removeOption = (index) => {
      // // Don't allow removing if only one option remains      
      const updatedOptionsData = [...optionsData];
      updatedOptionsData.splice(index, 1);
      setOptionsData(updatedOptionsData);
    };
  
    const save = () => {
      // Filter out empty options before saving
      const validOptions = optionsData.filter(option => option.trim() !== "");
      saveOptions(validOptions.length, validOptions);
      toggle();
    };

    const handleCancel = () => {
      // Reset to initial state when canceling
      setOptionsData(initialOptionsData);
      if (onCancel) {
        onCancel();
      } else {
        toggle();
      }
    };
  
    return (
      <Modal isOpen={isOpen} centered size="lg">
        <ModalHeader toggle={handleCancel}>{lang.add_options}</ModalHeader>
        <div className="p-3">
          {optionsData &&
            optionsData.map((value, index) => (
              <Row key={index}>
                <Col>
                  <Row>
                    <Col>
                      <label className="pb-1 fs-15 roboto-medium">
                        {lang?.option + " " + (index + 1)}
                      </label>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <input
                        type="text"
                        className="py-2 form-control"
                        placeholder={lang?.option + " " + (index + 1)}
                        value={value}
                        onChange={(e) =>
                          setOptionsData((prev) =>
                            prev.map((option, i) =>
                              i === index ? e.target.value : option
                            )
                          )
                        }
                      />
                    </Col>
  
                    <Col md={1} className="align-self-center">
                      <button
                        className={`rounded border-0 fw-bold px-2 ${
                          optionsData.length <= 1 
                            ? 'text-muted' 
                            : 'text-danger'
                        }`}
                        onClick={() => removeOption(index)}
                        style={{                          
                          cursor: 'pointer'
                        }}
                      >
                        x
                      </button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            ))}
          <Row className="mt-3">
            <Col className="text-end">
              <button
                className="bg-white rounded text-black fw-bold px-4 py-1"
                style={{ border: "1px solid #1DC1DD" }}
                onClick={addOption}
              >
                {lang?.add_option}
              </button>
            </Col>
          </Row>
        </div>
        <ModalFooter className="gap-3">
          <button className="btn btn-secondary px-5" onClick={handleCancel}>
            {lang?.cancel}
          </button>
          <button className="btn-blue border-0 py-2 px-5" onClick={save}>
            {lang?.save}
          </button>
        </ModalFooter>
      </Modal>
    );
  };

export default AddMultipleOptionModal;